import { create } from "zustand";
import { useDeleteAccountModalStore } from "./delete-account-modal-store";
import { useEditColorCollectionsStore } from "./edit-color-collections-store";
import { useMySavedColorsModalStore } from "./my-saved-colors-modal-store";
import { useMyStyleModalStore } from "./my-style-modal-store";
import { useProfileImageModalStore } from "./profile-image-modal-store";
import { useAddSavedColorsToCollectionModalStore } from "./add-saved-colors-to-collection-modal-store";
import { useAddToColorCollectionModalStore } from "~/js/stores/add-to-color-collection-modal-store";

export const useInviteFriendModalStore = create((set) => ({
  isModalOpen: false,
  inviteFriendUrl: null,
  openModal: (url) => {
    useDeleteAccountModalStore.getState().closeModal();
    useEditColorCollectionsStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();
    useAddSavedColorsToCollectionModalStore.getState().closeModal();
    useAddToColorCollectionModalStore.getState().closeModal();

    set({ isModalOpen: true, inviteFriendUrl: url });
  },
  closeModal: () => set({ isModalOpen: false, inviteFriendUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));
